import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { defaultMemoize } from 'reselect'
import { Link } from 'react-router-dom'
import qs from 'qs'
import MediaQuery from 'react-responsive'
import withStyles from 'material-ui-next/styles/withStyles'
import IconButton from 'material-ui-next/IconButton'
import Icon from 'material-ui-next/Icon'
import Toolbar from 'material-ui-next/Toolbar'
import Select from 'material-ui-next/Select'
import { MenuItem } from 'material-ui-next/Menu'
import MessageModal from '../../Swap/MessageModal'
import WorldsAndCategoriesDropdowns from '../WorldsAndCategoriesDropdowns'

import breakpoints from '../../../styles/breakpoints'
import { makeAuthenticatedApi } from '../../../api'
import { parseQsArg } from '../../../utils'

const styles = theme => ({
  ...theme.swapick.styles.toolbars,
  toolbar: {
    ...theme.swapick.styles.toolbars.secondaryToolbar,
    justifyContent: 'center',
  },
  filterToolbar: {
    ...theme.swapick.styles.toolbars.secondaryToolbar,
    justifyContent: 'center',
  },
  typo: {
    // TODO: Understand why not piglia roboto by default... fuck
    fontFamily: 'Roboto, sans-serif',
    color: theme.swapick.colors.neutral,
    fontSize: 13,
    fontWeight: 500,
    letterSpacing: '0.8px',
    textTransform: 'uppercase',
    textDecoration: 'none',
    paddingRight: 46,
  },
  // TODO: Move in theme....
  selectRoot: {
    color: theme.swapick.colors.positive,
    textTransform: 'uppercase',
    paddingTop: 3,
    fontSize: 14,
    marginRight: 15,
    height: '32px',
    letterSpacing: 0.8,
  },
  select: {
    backgroundColor: theme.swapick.colors.secondaryToolbar,
    '&:focus': {
      backgroundColor: theme.swapick.colors.secondaryToolbar,
    },
  },
  selectIcon: {
    color: theme.swapick.colors.primary,
  },
  menuItem: {
    ...theme.swapick.styles.dropdown.menuItem,
  },
  selectedMenuItem: {
    color: `${theme.swapick.colors.secondary}!important`,
  },
  iconButton: {
    color: theme.swapick.colors.positive,
  },
  filterBtn: {
    color: theme.swapick.colors.primary,
  },
  filterBtnActive: {
    color: theme.swapick.colors.secondary,
  },
  [`@media (max-width: ${breakpoints.xs})`]: {
    selectRoot: {
      fontSize: 11,
    },
    menuItem: {
      fontSize: 10,
    },
  },
})

class UserToolbar extends PureComponent {
  state = {
    messageModalOpen: false,
    filterToolBarOpen: false,
  }

  toggleMessageModalOpen = () => {
    this.setState(state => ({ messageModalOpen: !state.messageModalOpen }))
  }

  togglefilterToolBarOpen = () => {
    this.setState(state => ({ filterToolBarOpen: !state.filterToolBarOpen }))
  }

  makeMakeLinkTo = defaultMemoize(pathname => ({ world, category }) => {
    // Make links to world and category
    return `${pathname}?${qs.stringify({
      world: world ? world.slug : undefined,
      category: category ? category.slug : undefined,
    })}`
  })

  render() {
    const {
      classes,
      user,
      userInfo,
      counts,
      loading,
      error,
      location,
      world,
      category,
      worldSlug,
      categorySlug,
    } = this.props

    return (
      <span>
        <Toolbar className={classes.toolbar}>
          {userInfo &&
            <div className={classes.toolbarGroup}>
              <MediaQuery minWidth={breakpoints.xs}>
                <span className={classes.typo}>{userInfo.username}</span>
              </MediaQuery>
              <Select
                value={location.pathname}
                disableUnderline
                classes={{
                  root: classes.selectRoot,
                  icon: classes.selectIcon,
                  select: classes.select,
                }}>
                <MenuItem
                  classes={{
                    root: classes.menuItem,
                    selected: classes.selectedMenuItem,
                  }}
                  value={`/user/${userInfo.username}/items/owned`}
                  component={Link}
                  to={`/user/${userInfo.username}/items/owned`}>
                  Possiede ({counts.ownedItems || ''})
                </MenuItem>
                <MenuItem
                  classes={{
                    root: classes.menuItem,
                    selected: classes.selectedMenuItem,
                  }}
                  value={`/user/${userInfo.username}/items/wanted`}
                  component={Link}
                  to={`/user/${userInfo.username}/items/wanted`}>
                  Vuole ({counts.wantedItems || ''})
                </MenuItem>
                <MenuItem
                  classes={{
                    root: classes.menuItem,
                    selected: classes.selectedMenuItem,
                  }}
                  value={`/user/${userInfo.username}/items/can-get`}
                  component={Link}
                  to={`/user/${userInfo.username}/items/can-get`}>
                  Scambia ({counts.itemsICanGet || ''})
                </MenuItem>
              </Select>

              <MediaQuery minWidth={breakpoints.xs}>
                <WorldsAndCategoriesDropdowns
                  showAllWorlds={true}
                  showAllCategories={true}
                  worldSlug={worldSlug}
                  categorySlug={categorySlug}
                  makeLinkTo={this.makeMakeLinkTo(location.pathname)}
                />
              </MediaQuery>

              <MediaQuery maxWidth={breakpoints.xs}>
                <IconButton
                  className={
                    worldSlug || categorySlug
                      ? classes.filterBtnActive
                      : classes.filterBtn
                  }
                  onClick={this.togglefilterToolBarOpen}>
                  <Icon>filter_list</Icon>
                </IconButton>
              </MediaQuery>

              {/* Cant't message ma self eheh */}
              {user &&
                user.id !== userInfo.id &&
                <IconButton
                  onClick={this.toggleMessageModalOpen}
                  className={classes.iconButton}>
                  <Icon>email</Icon>
                </IconButton>}
              <MessageModal
                user={userInfo}
                open={this.state.messageModalOpen}
                onRequestClose={this.toggleMessageModalOpen}
                onSubmit={({ text }) => {
                  return this.props.api.sendMessage(userInfo.id, text)
                }}
                onSubmitSuccess={() => {
                  this.toggleMessageModalOpen()
                }}
              />
            </div>}
        </Toolbar>
        {this.state.filterToolBarOpen &&
          <Toolbar className={classes.filterToolbar} disableGutters={true}>
            <WorldsAndCategoriesDropdowns
              showAllWorlds={true}
              showAllCategories={true}
              worldSlug={worldSlug}
              categorySlug={categorySlug}
              makeLinkTo={this.makeMakeLinkTo(location.pathname)}
            />
          </Toolbar>}
      </span>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  api: makeAuthenticatedApi(state),
  userInfo: state.otherUser.info.data,
  user: state.auth.user,
  // TODO: Bad path find better names :P
  counts: state.otherUser.counts.counts,
  loading: state.otherUser.info.loading,
  error: state.otherUser.info.error,
  worldSlug: parseQsArg(ownProps.location, 'world'),
  categorySlug: parseQsArg(ownProps.location, 'category'),
})

export default withRouter(
  withStyles(styles)(connect(mapStateToProps)(UserToolbar))
)



// WEBPACK FOOTER //
// ./src/common/TopBar/SecondaryToolbars/UserToolbar.js